export default [
    {
        path: '/training-camp/index',
        component: () => import('@/views/training-camp/index.vue'),
        meta: {
            title: '训练基地',
        },
    },
    {
        path: '/training-camp/details',
        meta: {
            title: '训练营管理-详情',
        },
        component: () => import('@/views/training-camp/details.vue'),
    },
];
